const FilterOperator = {
	IS: "IS",
	IS_NOT: "IS NOT",
	LIKE: "LIKE",
	NOT_LIKE: "NOT LIKE",
	GT: "GREATER THAN",
	LT: "LESS THAN"
};
export default FilterOperator;
